import ApiServices from '@/services/apiServices'

export class Todo extends ApiServices {
  getAllOperator(params) {
    return this.http.get('/dk/dkAllDebtOperator', { params })
  }
}

export default new Todo('/')
